// React
import React from "react";
// Framework
import { usePortal } from "stack/core";
import { useStackDependency } from "stack/dependency";

////////////////////////////////////////////////////
/// Component
////////////////////////////////////////////////////

const TimeProvider = ({ children }) => {
  // Framework
  const { time } = usePortal();
  // Init
  useStackDependency(time);
  // Render
  return <>{children}</>;
};

export { TimeProvider };
